// extracted by mini-css-extract-plugin
export var aligned = "Stack-module--aligned--9dd05";
export var fill = "Stack-module--fill--941fa";
export var grow = "Stack-module--grow--0c368";
export var horizontal = "Stack-module--horizontal--14d15";
export var justified = "Stack-module--justified--85a02";
export var ordered = "Stack-module--ordered--95f85";
export var reverse = "Stack-module--reverse--c3f84";
export var shrink = "Stack-module--shrink--153e2";
export var stack = "Stack-module--stack--73ed5";
export var wrap = "Stack-module--wrap--7cb0d";